module['exports'] = ['گاوْں', 'گلی', 'آباد', 'کالونی', 'گھڑی'];
